// extracted by mini-css-extract-plugin
export default {"hamburgerMenuWrapper":"HamburgerMenu-module--hamburger-menu-wrapper--3f48b"};